<template>
	<div class="skeleton-bar" :class="{ double }" />
</template>

<script>
export default {
	name: 'SkeletonBar',
	props: { double: { type: Boolean, default: null } },
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

@keyframes skeleton {
	to {
		background-position: 250% 0;
	}
}

.skeleton-bar {
	--highlight-color: lightgray;
	width: 100%;
	border-radius: 6px;
	background-color: rgba(#e5e6ea, 0.5);
	background-image: linear-gradient(
		90deg,
		rgba(lightgrey, 0) 0,
		rgba(lightgrey, 0.6) 50%,
		rgba(lightgrey, 0) 100%
	);
	background-size: 50% 55px;
	background-position: -100% 0;
	background-repeat: no-repeat;
	animation: skeleton 2s ease-in-out infinite;
	&.double {
		background-image: linear-gradient(
			90deg,
			rgba(lightgrey, 0) 0,
			rgba(lightgrey, 0.6) 20%,
			rgba(lightgrey, 0) 40%,
			rgba(lightgrey, 0) 60%,
			rgba(lightgrey, 0.6) 80%,
			rgba(lightgrey, 0) 100%
		);
	}
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.skeleton-bar {
		background-color: rgba(#4e4e4f, 0.5);
		background-image: linear-gradient(
			90deg,
			rgba(darkgray, 0) 0,
			rgba(darkgray, 0.6) 50%,
			rgba(darkgray, 0) 100%
		);
		&.double {
			background-image: linear-gradient(
				90deg,
				rgba(darkgray, 0) 0,
				rgba(darkgray, 0.6) 20%,
				rgba(darkgray, 0) 40%,
				rgba(darkgray, 0) 60%,
				rgba(darkgray, 0.6) 80%,
				rgba(darkgray, 0) 100%
			);
		}
	}
}
</style>
